<div class="card">
    <div class="card-body">
        <div class="control-section">
            <ejs-grid [dataSource]='data' gridLines="None" [query]='query' [editSettings]="editSettings"
                [toolbar]="toolbar" [columns]='columns' allowSorting="true" [sortSettings]="sortSettings"
                (actionBegin)='actionBegin($event)' (actionComplete)='actionComplete($event)'>
                <ng-template #callTypeTemplate let-data>
                    <div>
                        <span>{{ data.RelatedTypeId == relatedConditions?.[0]?.relatedTypeId ? "" : "**" }}
                            {{data.ActivityType.Name}}</span>
                        <span class="float-end">{{ formatDateTime(data.DateTime) }} <br>
                            {{data.CreatedBy.FirstName}}</span>
                    </div>
                    <div class="mt-1">
                        <span>{{data.Name}}</span>
                    </div>
                </ng-template>
                <ng-template #detailTemplate let-data>
                    <div *ngIf="data.ActivityTypeId == 1">
                        <div class="text-dark col-12">{{data.ActivityCall.Type}} -
                            <span class="text-muted font-16">{{data.ActivityCall.Comments}}</span>
                        </div>
                    </div>
                    <div *ngIf="data.ActivityTypeId == 2">
                        <div class="row">
                            <div class="row task-dates">
                                <div class="col-4">
                                    <div class="mt-2">
                                        <h5 class="font-size-14"><i class="mdi-list-status me-1 text-primary"></i>
                                            Status</h5>
                                        <p class="text-muted mb-0">{{data.ActivityTask.Status}}</p>
                                    </div>
                                </div>

                                <div class="col-4">
                                    <div class="mt-2">
                                        <h5 class="font-size-14"><i class="bx bx-calendar me-1 text-primary"></i>
                                            Due Date</h5>
                                        <p class="text-muted mb-0">{{data.ActivityTask.DueDate | date:'dd-MM-yy
                                            hh:mm a'}}</p>
                                    </div>
                                </div>

                                <div class="col-4">
                                    <div class="mt-2">
                                        <h5 class="font-size-14"><i class="bx bx-calendar-check me-1 text-primary"></i>
                                            Completed Date
                                        </h5>
                                        <p class="text-muted mb-0">{{data.ActivityTask.CompletedDate |
                                            date:'dd-MM-yy hh:mm a'}}</p>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="mt-2">
                                        <h5 class="font-size-14"><i class="bx bx-calendar-check me-1 text-primary"></i>
                                            Description</h5>
                                        <p class="text-muted mb-0">{{data.ActivityTask.Description}}</p>
                                    </div>
                                </div>

                            </div>
                            <!-- <div class="text-dark col-4">DueDate - <span class="text-muted font-16">{{data.ActivityTask.DueDate | date:'dd-MM-yy hh:mm a'}}</span></div>
                <div class="text-dark col-4">CompletedDate - <span class="text-muted font-16">{{data.ActivityTask.CompletedDate | date:'dd-MM-yy hh:mm a'}}</span></div> -->
                        </div>
                        <!-- <div class="text-dark">Description - <span class="text-muted font-16">{{data.ActivityTask.Description}}</span></div> -->
                    </div>
                    <div *ngIf="data.ActivityTypeId == 3">
                        <div class="row">
                            <div class="text-dark col-4"><span
                                    class="text-muted font-16">{{data.ActivityEvents.Type}}</span></div>
                            <div class="text-dark col-4">Start - <span
                                    class="text-muted font-16">{{data.ActivityEvents.Start | date:'dd-MM-yy hh:mm
                                    a'}}</span></div>
                            <div class="text-dark col-4">End - <span
                                    class="text-muted font-16">{{data.ActivityEvents.End |
                                    date:'dd-MM-yy hh:mm a'}}</span></div>
                        </div>
                        <div class="text-dark">Description - <span
                                class="text-muted font-16">{{data.ActivityEvents.Description}}</span></div>
                    </div>
                    <div *ngIf="data.ActivityTypeId == 4">
                        <div class="row">
                            <div class="text-dark col-4">From - <span
                                    class="text-muted font-16">{{data.ActivityEmail.From}}</span></div>
                            <div class="text-dark col-4">To - <span
                                    class="text-muted font-16">{{data.ActivityEmail.To}}</span></div>
                            <div class="text-dark col-4">CC - <span
                                    class="text-muted font-16">{{data.ActivityEmail.CC}}</span></div>
                            <div class="text-dark col-4">BCC - <span
                                    class="text-muted font-16">{{data.ActivityEmail.BCC}}</span></div>
                            <div class="text-dark col-4">Subject - <span
                                    class="text-muted font-16">{{data.ActivityEmail.Subject}}</span></div>
                        </div>
                        <div class="text-dark">Body - <span
                                class="text-muted font-16">{{data.ActivityEmail.Body}}</span>
                        </div>
                    </div>
                </ng-template>
                <ng-template #editSettingsTemplate let-data>
                    <div [formGroup]="formData">
                        <div class="row">
                            <div class="col-3">
                                <input class="form-check-input" type="radio" name="flexRadioDefault"
                                    id="flexRadioDefault1" [checked]="f.ActivityTypeId.value == 1 ? true : false"
                                    (click)="setType('Call')">
                                <label class="form-check-label mx-1" for="flexRadioDefault1">Call</label>
                            </div>
                            <div class="col-3">
                                <input class="form-check-input" type="radio" name="flexRadioDefault"
                                    id="flexRadioDefault2" [checked]="f.ActivityTypeId.value == 2 ? true : false"
                                    (click)="setType('Task')">
                                <label class="form-check-label mx-1" for="flexRadioDefault2">
                                    Task
                                </label>
                            </div>
                            <div class="col-3">
                                <input class="form-check-input" type="radio" name="flexRadioDefault"
                                    id="flexRadioDefault1" [checked]="f.ActivityTypeId.value == 3 ? true : false"
                                    (click)="setType('Event')">
                                <label class="form-check-label mx-1" for="flexRadioDefault1">
                                    Event
                                </label>
                            </div>
                            <div class="col-3">
                                <input class="form-check-input" type="radio" name="flexRadioDefault"
                                    id="flexRadioDefault1" [checked]="f.ActivityTypeId.value == 4 ? true : false"
                                    (click)="setType('Email')">
                                <label class="form-check-label mx-1" for="flexRadioDefault1">
                                    Email
                                </label>
                            </div>
                        </div>
                        <div class="row">

                            <div class="form-group col-lg-6">
                                <ejs-datetimepicker formControlName="DateTime" name="DateTime" readonly
                                    cssClass='{{ f.DateTime.invalid && submitClicked ? "e-error" : ""}}'
                                    placeholder='Date and Time*' floatLabelType='Always'
                                    [format]='"dd-MMM-yyyy hh:mm a"'>
                                </ejs-datetimepicker>
                                @if(( f.DateTime.invalid && submitClicked)){
                                <div id="StatusError">
                                    <label class="e-error" for="Name" id="Name-info"
                                        style="display: block;">*required</label>
                                </div>
                                }
                            </div>
                            <div class="form-group col-lg-6">
                                <ejs-autocomplete id='ActivityStatusId' [allowCustom]="false"
                                    [dataSource]='activityStatusData'
                                    cssClass='{{ f.ActivityStatusId.invalid && submitClicked ? "e-error" : ""}}'
                                    formControlName="ActivityStatusId" name="ActivityStatusId"
                                    [query]="activityStatusQuery" [fields]='{text:"Name", value:"Id"}'
                                    placeholder='Status*' [showPopupButton]="true"
                                    (filtering)="onFiltering($event,'as')" floatLabelType="Always"></ejs-autocomplete>
                                @if(( f.ActivityStatusId.invalid && submitClicked)){
                                <div id="StatusError">
                                    <label class="e-error" for="Name" id="Name-info"
                                        style="display: block;">*required</label>
                                </div>
                                }
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-lg-3" formGroupName="ActivityCall"
                                *ngIf="f.ActivityTypeId.value == 1">
                                <ejs-autocomplete id='Type'
                                    cssClass='{{ ac.Type.invalid && submitClicked ? "e-error" : ""}}'
                                    [dataSource]='callTypeData' [allowCustom]="false" [showPopupButton]="true"
                                    formControlName="Type" name="Type" [query]="callTypeQuery"
                                    [fields]='{text:"Name", value:"Id"}' placeholder='Call Type*'
                                    (filtering)="onFiltering($event,'ct')" floatLabelType="Always"></ejs-autocomplete>
                                @if(( ac.Type.invalid && submitClicked)){
                                <div id="StatusError">
                                    <label class="e-error" for="Name" id="Name-info"
                                        style="display: block;">*required</label>
                                </div>
                                }
                            </div>
                            <div class="form-group  col-lg-9">
                                <div class="e-float-input e-control-wrapper"
                                    [ngClass]="{'e-error': f.Name.invalid && submitClicked}">
                                    <input formControlName="Name" data-msg-containerid='NameError' id="Name" name="Name"
                                        type="text" [ngClass]='{"e-error": f.Name.invalid && submitClicked}'>
                                    <span class="e-float-line"></span>
                                    <label class="e-float-text e-label-top" for="Name">Name*</label>
                                </div>
                                @if(( f.Name.invalid && submitClicked)){
                                <div id="StatusError">
                                    <label class="e-error" for="Name" id="Name-info"
                                        style="display: block;">*required</label>
                                </div>
                                }
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12" formGroupName="ActivityCall"
                                *ngIf="f.ActivityTypeId.value == 1">
                                <div class="e-float-input e-control-wrapper">
                                    <div class="e-float-input e-control-wrapper"
                                        [ngClass]="{'e-error': ac.Comments.invalid && submitClicked}">
                                        <textarea formControlName="Comments"
                                            [ngClass]='{"e-error": submitClicked && ac.Comments.invalid }' id="Comments"
                                            name="Comments" type="text" rows="5">
                                            </textarea>
                                        <span class="e-float-line"></span>
                                        <label class="e-float-text e-label-top" for="Comments">Comments</label>
                                    </div>
                                    @if(( ac.Comments.invalid && submitClicked )){
                                    <div id="CommentsError">
                                        <label class="e-error" for="Comments" id="Comments-info"
                                            style="display: block;">*required</label>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="row" formGroupName="ActivityTask" *ngIf="f.ActivityTypeId.value == 2">
                            <div class="form-group col-lg-4">
                                <div class="e-float-input e-control-wrapper"
                                    [ngClass]="{'e-error': at.Status.invalid && submitClicked}">
                                    <input type="text" [ngClass]='{"e-error": at.Status.invalid && submitClicked }'
                                        id="Status" name="Status" class="required" data-msg-containerid='StatusError'
                                        formControlName="Status" required>
                                    <span class="e-float-line"></span>
                                    <label class="e-float-text e-label-top" for="Status">Status</label>
                                </div>
                                @if(( at.Status.invalid && submitClicked )) {
                                <div id="StatusError">
                                    <label class="e-error" for="Status" id="Status-info"
                                        style="display: block;">*required</label>
                                </div>
                                }
                            </div>
                            <div class="form-group col-lg-4">
                                <ejs-datetimepicker formControlName="DueDate" name="DueDate" placeholder='Due Date'
                                    class="required" floatLabelType='Always' [format]='"dd-MMM-yyyy hh:mm a"'>
                                </ejs-datetimepicker>


                            </div>
                            <div class="form-group col-lg-4">
                                <ejs-datetimepicker formControlName="CompletedDate" name="CompletedDate"
                                    placeholder='Completed Date' floatLabelType='Always'
                                    [format]='"dd-MMM-yyyy hh:mm a"'>
                                </ejs-datetimepicker>
                            </div>
                            <div class="form-group col-12">
                                <div class="e-float-input e-control-wrapper">
                                    <div class="e-float-input e-control-wrapper"
                                        [ngClass]="{'e-error': at.Description.invalid && submitClicked}">
                                        <textarea formControlName="Description"
                                            [ngClass]='{"e-error": at.Description.invalid && submitClicked }'
                                            id="Description" name="Description" type="text" rows="5"></textarea>
                                        <span class="e-float-line"></span>
                                        <label class="e-float-text e-label-top" for="Description">Description</label>
                                    </div>
                                    @if(( at.Description.invalid && submitClicked )){
                                    <div id="StatusError">
                                        <label class="e-error" for="Name" id="Name-info"
                                            style="display: block;">*required</label>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div class="row" formGroupName="ActivityEvents" *ngIf="f.ActivityTypeId.value == 3">
                            <div class="form-group col-lg-6">
                                <ejs-autocomplete id='Type' [allowCustom]="false" [dataSource]='eventTypeData'
                                    formControlName="Type" name="Type" [query]="eventTypeQuery"
                                    [fields]='{text:"Name", value:"Id"}'
                                    cssClass='{{ ae.Type.invalid && submitClicked ? "e-error" : ""}}'
                                    placeholder='Event Type' [showPopupButton]="true"
                                    (filtering)="onFiltering($event,'et')" (change)="changeEventType($event)" floatLabelType="Always"></ejs-autocomplete>
                                @if(( ae.Type.invalid && submitClicked )){
                                <div id="StatusError">
                                    <label class="e-error" for="Name" id="Name-info"
                                        style="display: block;">*required</label>
                                </div>
                                }
                            </div>
                            <div class="form-group col-lg-5">
                                <div class="e-float-input e-control-wrapper"
                                    [ngClass]="{'e-error': ae.Location.invalid && submitClicked}">
                                    <input type="text" id="Location" name="Location" class="required"
                                        formControlName="Location" required>
                                    <span class="e-float-line"></span>
                                    <label class="e-float-text" for="Location">Location</label>
                                </div>
                                @if((ae.Location.invalid && submitClicked)){
                                <div id="LocationError">
                                    <label class="e-error" for="Location" id="Location-info"
                                        style="display: block;">*required</label>
                                </div>
                                }
                            </div>
                            @if(!ae.Latitude.value)
                            {
                                <div class="form-group col-lg-1">
                                    <div class="e-float-input"></div>
                                    <button type="button" class="btn btn-sm btn-primary" (click)="setCurrentLocation()">
                                        <span><i class='bx bx-map fs-5'></i></span>
                                    </button>
                                </div>
                            }
                            <div class="row">
                                <div class="form-group col-lg-6">
                                    <ejs-datetimepicker formControlName="Start" name="Start" placeholder="Start"
                                        class="required" floatLabelType='Always'
                                        [format]='"dd-MMM-yyyy hh:mm a"'></ejs-datetimepicker>
                                </div>
                                <div class="form-group col-lg-6">
                                    <div class="d-flex align-items-end gap-2">
                                        <ejs-datetimepicker formControlName="End" name="End" placeholder="End"
                                            class="required flex-grow-1" floatLabelType="Always"
                                            [format]="'dd-MMM-yyyy hh:mm a'">
                                        </ejs-datetimepicker>

                                        <button class="btn btn-sm btn-primary" (click)="setCompleteDateTime()"
                                            type="button">
                                            <span><i class='bx bx-stop-circle'></i> </span>
                                        </button>
                                    </div>
                                </div>

                            </div>
                            <div class="form-group col-12">
                                <div class="e-float-input e-control-wrapper">
                                    <div class="e-float-input e-control-wrapper"
                                        [ngClass]="{'e-error': ae.Description.invalid && submitClicked}">
                                        <textarea formControlName="Description" id="Description" name="Description"
                                            type="text" rows="5"></textarea>
                                        <span class="e-float-line"></span>
                                        <label class="e-float-text e-label-top" for="Description">Description</label>
                                    </div>
                                    @if(( ae.Description.invalid && submitClicked )){
                                    <div id="StatusError"
                                        [style.visibility]='(( ae.Description.invalid && submitClicked ))? "visible": "hidden"'>
                                        <label class="e-error" for="Name" id="Name-info"
                                            style="display: block;">*required</label>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>

                        <div class="row" formGroupName="ActivityEmail" *ngIf="f.ActivityTypeId.value == 4">
                            <div class="form-group col-12">
                                <div class="e-float-input e-control-wrapper"
                                    [ngClass]="{'e-error': am.From.invalid && submitClicked}">
                                    <input type="text" id="From" name="From" formControlName="From">
                                    <span class="e-float-line"></span>
                                    <label class="e-float-text e-label-top" for="From">From</label>
                                </div>
                                @if(( am.From.invalid && submitClicked )){
                                <div id="StatusError">
                                    <label class="e-error" for="Name" id="Name-info"
                                        style="display: block;">*required</label>
                                </div>
                                }
                            </div>
                            <div class="form-group col-12">
                                <div class="e-float-input e-control-wrapper"
                                    [ngClass]="{'e-error': am.To.invalid && submitClicked}">
                                    <input type="text" id="To" name="To" formControlName="To">
                                    <span class="e-float-line"></span>
                                    <label class="e-float-text e-label-top" for="To">To</label>
                                </div>
                                <div id="StatusError"
                                    [style.visibility]='(( am.To.invalid && submitClicked ))? "visible": "hidden"'>
                                    <label class="e-error" for="Name" id="Name-info"
                                        style="display: block;">*required</label>
                                </div>

                            </div>
                            <div class="form-group col-12">
                                <div class="e-float-input e-control-wrapper">
                                    <input type="text" id="CC" name="CC" formControlName="CC">
                                    <span class="e-float-line"></span>
                                    <label class="e-float-text e-label-top" for="CC">CC</label>
                                </div>

                            </div>
                            <div class="form-group col-12">
                                <div class="e-float-input e-control-wrapper">
                                    <input type="text" id="BCC" name="BCC" formControlName="BCC">
                                    <span class="e-float-line"></span>
                                    <label class="e-float-text e-label-top" for="BCC">BCC</label>

                                </div>
                            </div>
                            <div class="form-group col-12">
                                <div class="e-float-input e-control-wrapper"
                                    [ngClass]="{'e-error': am.Subject.invalid && submitClicked}">
                                    <input type="text" id="Subject" name="Subject" formControlName="Subject">
                                    <span class="e-float-line"></span>
                                    <label class="e-float-text e-label-top" for="Subject">Subject</label>
                                </div>
                                @if(( am.Subject.invalid && submitClicked )){
                                <div id="SubjectError">
                                    <label class="e-error" for="Subject" id="Subject-info"
                                        style="display: block;">*required</label>
                                </div>
                                }
                            </div>
                            <div class="form-group col-12">
                                <div class="e-float-input e-control-wrapper"
                                    [ngClass]="{'e-error': am.Body.invalid && submitClicked}">
                                    <textarea formControlName="Body" id="Body" name="Body" type="text"
                                        rows="5"></textarea>
                                    <span class="e-float-line"></span>
                                    <label class="e-float-text e-label-top" for="Body">Body</label>
                                </div>
                                <div id="BodyError"
                                    [style.visibility]='(( am.Body.invalid && submitClicked ))? "visible": "hidden"'>
                                    <label class="e-error" for="Body" id="Body-info"
                                        style="display: block;">*required</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ejs-grid>
            <label>Previous Activities</label>
            <ejs-grid [dataSource]="oldActivityData" gridLines="None" [query]="oldActivityquery" allowPaging='true'
                [filterSettings]='oldActivityFilterSettings' [columns]="oldActivityColumns" allowSorting="true"
                [sortSettings]="sortSettings" [pageSettings]='pageOptions'>
                <ng-template #callTypeTemplate let-data>
                    <div>
                        <span>{{data.ActivityType.Name}}</span>
                        <span class="float-end">{{ formatDateTime(data.DateTime) }}</span>
                    </div>
                    <div class="mt-1">
                        <span>{{data.Name}} {{ data.CreatedBy.FirstName}}</span>
                    </div>
                </ng-template>
                <ng-template #detailTemplate let-data>
                    <div *ngIf="data.ActivityTypeId == 1">
                        <div class="text-dark col-12">{{data.ActivityCall.Type}} -
                            <span class="text-muted font-16">{{data.ActivityCall.Comments}}</span>
                        </div>
                    </div>
                    <div *ngIf="data.ActivityTypeId == 2">
                        <div class="row">
                            <div class="row task-dates">
                                <div class="col-4">
                                    <div class="mt-2">
                                        <h5 class="font-size-14"><i class="mdi-list-status me-1 text-primary"></i>
                                            Status</h5>
                                        <p class="text-muted mb-0">{{data.ActivityTask.Status}}</p>
                                    </div>
                                </div>

                                <div class="col-4">
                                    <div class="mt-2">
                                        <h5 class="font-size-14"><i class="bx bx-calendar me-1 text-primary"></i>
                                            Due Date</h5>
                                        <p class="text-muted mb-0">{{data.ActivityTask.DueDate | date:'dd-MM-yy
                                            hh:mm a'}}</p>
                                    </div>
                                </div>

                                <div class="col-4">
                                    <div class="mt-2">
                                        <h5 class="font-size-14"><i class="bx bx-calendar-check me-1 text-primary"></i>
                                            Completed Date
                                        </h5>
                                        <p class="text-muted mb-0">{{data.ActivityTask.CompletedDate |
                                            date:'dd-MM-yy hh:mm a'}}</p>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="mt-2">
                                        <h5 class="font-size-14"><i class="bx bx-calendar-check me-1 text-primary"></i>
                                            Description</h5>
                                        <p class="text-muted mb-0">{{data.ActivityTask.Description}}</p>
                                    </div>
                                </div>

                            </div>
                            <!-- <div class="text-dark col-4">DueDate - <span class="text-muted font-16">{{data.ActivityTask.DueDate | date:'dd-MM-yy hh:mm a'}}</span></div>
                <div class="text-dark col-4">CompletedDate - <span class="text-muted font-16">{{data.ActivityTask.CompletedDate | date:'dd-MM-yy hh:mm a'}}</span></div> -->
                        </div>
                        <!-- <div class="text-dark">Description - <span class="text-muted font-16">{{data.ActivityTask.Description}}</span></div> -->
                    </div>
                    <div *ngIf="data.ActivityTypeId == 3">
                        <div class="row">
                            <div class="text-dark col-4"><span
                                    class="text-muted font-16">{{data.ActivityEvents.Type}}</span></div>
                            <div class="text-dark col-4">Start - <span
                                    class="text-muted font-16">{{data.ActivityEvents.Start | date:'dd-MM-yy hh:mm
                                    a'}}</span></div>
                            <div class="text-dark col-4">End - <span
                                    class="text-muted font-16">{{data.ActivityEvents.End |
                                    date:'dd-MM-yy hh:mm a'}}</span></div>
                        </div>
                        <div class="text-dark">Description - <span
                                class="text-muted font-16">{{data.ActivityEvents.Description}}</span></div>
                    </div>
                    <div *ngIf="data.ActivityTypeId == 4">
                        <div class="row">
                            <div class="text-dark col-4">From - <span
                                    class="text-muted font-16">{{data.ActivityEmail.From}}</span></div>
                            <div class="text-dark col-4">To - <span
                                    class="text-muted font-16">{{data.ActivityEmail.To}}</span></div>
                            <div class="text-dark col-4">CC - <span
                                    class="text-muted font-16">{{data.ActivityEmail.CC}}</span></div>
                            <div class="text-dark col-4">BCC - <span
                                    class="text-muted font-16">{{data.ActivityEmail.BCC}}</span></div>
                            <div class="text-dark col-4">Subject - <span
                                    class="text-muted font-16">{{data.ActivityEmail.Subject}}</span></div>
                        </div>
                        <div class="text-dark">Body - <span
                                class="text-muted font-16">{{data.ActivityEmail.Body}}</span>
                        </div>
                    </div>
                </ng-template>
            </ejs-grid>
        </div>
    </div>
